<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Comments'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Comments'
        };
    },

    computed: {
        options() {
            return { addButton: false };
        },

        labels() {
            return [
                { value: 'details', text: 'Details', width: '150px' },
                { value: 'likes', type: 'number', width: '100px' },
                {
                    value: 'isReported',
                    type: 'boolean',
                    isBadge: true,
                    badgeOptions: {
                        trueVariant: 'danger',
                        falseVariant: 'success'
                    },
                    width: '100px'
                },
                {
                    value: 'user.fullName',
                    sortFieldName: 'user.firstName',
                    text: 'Author',
                    width: '150px'
                },
                {
                    width: '200px',
                    text: "Author's Campus",
                    sortable: false,
                    value: 'user.campuses',
                    filterFieldName: 'user.campuses.name',
                    filter: 'joinTable'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'comments/index',
            deleteItem: 'comments/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/comments/${id}/edit`);
        }
    }
};
</script>
